import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../../api/DBSchema/Gateway';
import {SMCCheckbox} from '../../../../../components/Simple/SMCCheckbox';
import {useTranslation} from 'react-i18next';
import PlanEditorInnerContainer from '../../../../../components/Editor/PlanEditorInnerContainer';
import Separator from '../../../../../components/Simple/Sepperator';
import Indentation from '../../../../../components/Simple/Indentation';

import {SMCRadio, SMCRadioGroup} from '../../../../../components/Simple/SMCRadio';
import SMCLabel from '../../../../../components/Simple/SMCLabel';
import {SMCSelect, SMCOption} from '../../../../../components/Simple/SMCSelect';
import EmptyRow from '../../../../../components/Simple/EmptyRow';
import EditorLayout from '../../../../../components/Layouts/EditorLayout';
import RowLayout from '../../../../../components/Layouts/RowLayout';
import SMCTextInput from '../../../../../components/Simple/SMCTextInput';
import {SMCToggleSwitch} from "../../../../../components/Simple/SMCToggleSwitch";

const pageSchema = GatewayGetSchema.pages.antiSpam;
const pageId = pageSchema.pageId;

function BaseAntiSpam({
    pageData,
    setObjectData,
    pageDisabled
}) {
    const { t } = useTranslation();

    const manageInSmp        = pageData[pageSchema.manageInSmp];
    const mode               = pageData[pageSchema.mode];
    const contentBasedFilter = pageData[pageSchema.contentBasedFilter];
    const spamAction         = pageData[pageSchema.spamAction];
    const spamEmailSubject   = pageData[pageSchema.spamEmailSubject];
    const track              = pageData[pageSchema.track];
    const detectOnly         = pageData[pageSchema.detectOnly];

    const spamActionValues = pageSchema.spamActionValues;
    const trackValues      = pageSchema.trackValues;


    const setPageValue = useCallback((param, newValue) => {
        setObjectData([pageId, param], newValue);
    }, [setObjectData]);


    return (
        <EditorLayout>
            <SMCToggleSwitch
                disabled={pageDisabled}
                checked={manageInSmp}
                onChange={checked => setPageValue(pageSchema.manageInSmp, checked)}
                label={t('SMP.PLAN.MANAGE_IN_SMP')}
            />
            <Separator isMainSeparator/>
            <PlanEditorInnerContainer title={t('SMP.PLAN.ANTI_SPAM.ANTI_SPAM')} managedInSmp={manageInSmp}>
                <RowLayout>
                    <SMCRadioGroup value={mode ? 'ON' : 'OFF'} onChange={e => setPageValue(pageSchema.mode, e.target.value === 'ON')} disabled={pageDisabled || !manageInSmp}>
                        <SMCRadio value="ON" label={t('SMP.ON')} />
                        <SMCRadio value="OFF" label={t('SMP.OFF')} />
                    </SMCRadioGroup>
                </RowLayout>
                                
                <EmptyRow />

                <SMCLabel bold>{t('SMP.PLAN.SEC_SOFT_BLADES.POLICY')}:</SMCLabel>
                {/* Is filtered */}
                <SMCCheckbox
                    disabled={pageDisabled || !manageInSmp}
                    checked={contentBasedFilter}
                    onChange={e => setPageValue(pageSchema.contentBasedFilter, e.target.checked)}
                    label={t('SMP.PLAN.ANTI_SPAM.LINE1')}
                />
                {/* Spam action */}
                <Indentation>
                    <SMCRadioGroup
                        value={spamAction}
                        onChange={e => setPageValue(pageSchema.spamAction, e.target.value)}
                        disabled={pageDisabled || !manageInSmp || !contentBasedFilter}
                    >
                        <SMCRadio value={spamActionValues.blockSpamEmails} label={t('SMP.PLAN.ANTI_SPAM.BLOCK_SPAM_EMAILS')} />
                        <SMCRadio value={spamActionValues.flagSpamEmailSubject} label={t('SMP.PLAN.ANTI_SPAM.FLAG_SPAM_EMAIL_SUBJECT')} />
                        {
                            spamAction === spamActionValues.flagSpamEmailSubject && (
                                <Indentation>
                                    <SMCTextInput
                                        value={spamEmailSubject}
                                        onChange={e => setPageValue(pageSchema.spamEmailSubject, e.target.value)}
                                        label={t('SMP.PLAN.ANTI_SPAM.FLAG_IT_WITH')}
                                    />
                                </Indentation>
                            )
                        }
                        <SMCRadio value={spamActionValues.flagSpamEmailHeader} label={t('SMP.PLAN.ANTI_SPAM.FLAG_SPAM_EMAIL_HEADER')} />
                    </SMCRadioGroup>
                </Indentation>
                
                <EmptyRow />

                {/* Tracking options */}
                <SMCSelect
                    value={track}
                    onChange={e => setPageValue(pageSchema.track, e.target.value)}
                    label={t('SMP.PLAN.T_ANTI_VIRUS.TRACKING_OPTIONS')}
                    disabled={pageDisabled || !manageInSmp}
                >
                    <SMCOption value={trackValues.log}>{t('SMP.LOG')}</SMCOption>
                    <SMCOption value={trackValues.alert}>{t('SMP.ALERT')}</SMCOption>
                    <SMCOption value={trackValues.none}>{t('SMP.NONE')}</SMCOption>
                </SMCSelect>
                {/* Detect-only */}
                <SMCCheckbox
                    disabled={pageDisabled || !manageInSmp}
                    checked={detectOnly}
                    onChange={e => setPageValue(pageSchema.detectOnly, e.target.checked)}
                    label={t('SMP.PLAN.DETECT_ONLY_MODE')}
                />

                <EmptyRow />

                <SMCLabel><b>{t('SMP.DESCRIPTION')}: </b>{t('SMP.PLAN.ANTI_SPAM.LINE2')}</SMCLabel>
            </PlanEditorInnerContainer>
        </EditorLayout>
    );
}

export default BaseAntiSpam;